import { render, staticRenderFns } from "./order-reason-modal.vue?vue&type=template&id=6c263066&"
import script from "./order-reason-modal.vue?vue&type=script&lang=ts&"
export * from "./order-reason-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports